/**
 * Returns the current user from localStorage with role helpers.
 *
 * Roles:  admin | manager | employee
 * Employee has a job_title: technician | cleaner | electrician |
 *   plumber | security | receptionist | groundskeeper | other
 */
export function useAuth() {
    const user = JSON.parse(localStorage.getItem('fms_user') || '{}');
    const role = user.role || '';
    return {
        user,
        role,
        isAdmin: role === 'admin',
        isManager: role === 'manager',
        isEmployee: role === 'employee',
        isDeveloper: role === 'developer',
        // What each role can do
        canManageFacility: role === 'admin',
        canManageSpace: role === 'admin' || role === 'manager',
        canManageAssets: role === 'admin' || role === 'manager',
        canManageWO: role === 'admin' || role === 'manager',
        canManageUsers: role === 'admin' || role === 'manager' || role === 'developer',
        canViewSettings: role === 'admin' || role === 'developer',
        // Employee sees only My Tasks
        isEmployeeOnly: role === 'employee',
        // Assigned facility for manager/employee
        assignedFacility: user.assigned_facility || null,
        facilityId: user.facility_id || null,
    };
}
